// Reveals server-rendered blur images. CSS (html.js) hides them at first paint;
// here we fade the real image in once fully loaded — including already-cached
// ones (next frame) so the fade is consistent.

export function isLoaded(img) {
  return !!(img.complete && img.naturalWidth > 0);
}

function reveal(img) {
  img.classList.add('blurup__img--loaded');
}

export function enhance(img) {
  if (img.dataset.blurupDone) return;
  img.dataset.blurupDone = '1';

  if (isLoaded(img)) {
    requestAnimationFrame(() => reveal(img));
  } else {
    img.addEventListener('load', () => reveal(img), { once: true });
    // On error, still reveal so the user gets the native broken-image/alt instead of
    // being stuck on the blurred placeholder forever.
    img.addEventListener('error', () => reveal(img), { once: true });
  }
}

export function revealNow(img) {
  if (!img.classList.contains('blurup__img')) return;
  img.dataset.blurupDone = '1';
  img.style.transition = 'none';
  reveal(img);
}

export function initImageEnhancements(root = document) {
  root.querySelectorAll('img.blurup__img').forEach(enhance);
}
